import { CloseRounded } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'
import { deleteNovelty } from '../../../../../../redux/actions/novelties'
import { CancelButton, DeleteButton } from '../../../../../shared/components/inputs'
import useScreenWidth from '../../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../../shared/styles/FormsStyles'

interface DeleteNewsDialogProps {
  open: boolean
  newsSelected: number | boolean
  onClose: () => void
}

export const DeleteNewsDialog = ({ open, newsSelected, onClose }: DeleteNewsDialogProps) => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const theme = useTheme()
  const formClasses = formsStyles(theme)
  const isMobile = useScreenWidth(700)

  const handleDelete = () => {
    if (typeof newsSelected === 'number') {
      dispatch(deleteNovelty(newsSelected))
      onClose()
    }
  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      fullScreen={isMobile}
      maxWidth="sm"
      sx={formClasses.containerForm}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('news')}
          </Typography>
          <Button onClick={onClose} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={formClasses.bodyForm}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Typography>{t('admin.novelties.delete-news-text')}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose}>{t('cancel')}</CancelButton>
        <DeleteButton autoFocus id="btn-handleldelete" onClick={handleDelete}>
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </Dialog>
  )
}
